module.exports = __webpack_public_path__ + "img/transfer1.27eab4e6.jpeg";